import {
  MdOutlineDashboard,
  MdOutlineHistory,
  MdOutlinePeople,
  MdOutlineSavings,
  MdSupportAgent,
} from "react-icons/md";
import { HiOutlineCog8Tooth } from "react-icons/hi2";
import { AiOutlineProfile, AiOutlineRise } from "react-icons/ai";
import { BiMedal, BiMoneyWithdraw } from "react-icons/bi";
import {
  BsFacebook,
  BsInstagram,
  BsLinkedin,
  BsMedium,
  BsPlus,
  BsTiktok,
  BsTwitterX,
  BsWallet,
  BsYoutube,
} from "react-icons/bs";
import vant from "/public/vant.svg";
import providus from "/public/providus.svg";
import paystack from "/public/paystack.svg";
import palmpay from "/public/palmpay.svg";
import fcmb from "/public/fcmb.svg";
import pristin from "/public/pristin.svg";
import condia from "/public/condia.svg";
import techcabal from "/public/techcabal.svg";
import techcity from "/public/techcity.svg";
import technext from "/public/technext.svg";
import techpoint from "/public/techpoint.svg";

export const REFFERAL_SOURCE = [
  { label: "FACEBOOK", value: "FACEBOOK" },
  { label: "TWITTER", value: "TWITTER" },
  { label: "LINKEDIN", value: "LINKEDIN" },
  { label: "EMAIL NEWSLETTER", value: "EMAIL NEWSLETTER" },
  { label: "FAMILY & FRIENDS", value: "FAMILY & FRIENDS" },
  { label: "WHATSAPP", value: "WHATSAPP" },
];

export const OFTEN_OPTIONS = [
  { label: "DAILY", value: "DAILY" },
  { label: "WEEKLY", value: "WEEKLY" },
  { label: "MONTHLY", value: "MONTHLY" },
];

export const DAYS_OF_THE_WEEK = [
  { label: "SUNDAY", value: "SUNDAY" },
  { label: "MONDAY", value: "MONDAY" },
  { label: "TUESDAY", value: "TUESDAY" },
  { label: "WEDNESDAY", value: "WEDNESDAY" },
  { label: "THURSDAY", value: "THURSDAY" },
  { label: "FRIDAY", value: "FRIDAY" },
  { label: "SATURDAY", value: "SATURDAY" },
];

export const DEPOSIT_MODE = [
  { label: "Automatic", value: true },
  { label: "Manual", value: false },
];

export const NAV_LINKS = [
  {
    title: "Dashboard",
    route: "/dashboard",
    icon: (props) => <MdOutlineDashboard {...props} />,
  },
  {
    title: "Transaction History",
    route: "/transaction",
    icon: (props) => <MdOutlineHistory {...props} />,
  },
  {
    title: "Interest Breakdown",
    route: "/interest",
    icon: (props) => <AiOutlineRise {...props} />,
  },
  {
    title: "Settings",
    route: "/settings",
    icon: (props) => <HiOutlineCog8Tooth {...props} />,
  },
  {
    title: "Profile",
    route: "/profile",
    icon: (props) => <AiOutlineProfile {...props} />,
  },
  {
    title: "Contact Support",
    route: "/support",
    icon: (props) => <MdSupportAgent {...props} />,
  },
];

export const CLUSTERS = [
  {
    text: "Flexible Savings",
    bgColor: "bg-default",
    textColor: "text-primary",
    rotation: -5,
  },
  {
    text: "Target Savings",
    bgColor: "bg-secondary",
    textColor: "text-white",
    rotation: 5,
  },
  {
    text: "Lock Savings",
    bgColor: "bg-success",
    textColor: "text-white",
    rotation: -20,
  },
  {
    text: "House Money",
    bgColor: "bg-default",
    textColor: "text-black",
    rotation: 5,
  },
  {
    text: "Goal Savings",
    bgColor: "bg-[#0052D5]",
    textColor: "text-white",
    rotation: -5,
  },
  {
    text: "Emergency Fund",
    bgColor: "bg-default",
    textColor: "text-black",
    rotation: -5,
  },
];

export const CORE_VALUES = [
  {
    id: "transparent",
    title: "Complete Transparency",
    description:
      "See exactly where your money is and how it's growing. Every naira is accounted for with detailed transaction histories and real-time updates.",
    icon: "/find.svg",
    extraIcon: "/interest.svg",
  },
  {
    id: "information",
    title: "Instant Access to Information",
    description:
      "Check your savings balance, contribution history, and loan eligibility anytime, anywhere. No more waiting for monthly statements or co-operative meetings.",
    icon: "/doc.svg",
  },
  {
    id: "loan",
    title: "Faster Loan Processing",
    description:
      "Apply for loans digitally and track approval status in real-time. Get access to funds when you need them most, without the usual delays.",
    icon: "/loan.svg",
  },
  {
    id: "pay",
    title: "Easy Payment Management",
    description:
      "Set up automatic contributions and loan repayments. Never miss a payment with smart reminders and flexible payment options",
    icon: "/pay.svg",
    extraIcon: "/community.svg",
  },
];

export const ACTION_CARD = [
  {
    action: "Quick Deposit",
    icon: (props) => <BsPlus {...props} />,
    route: "/deposit",
    id: "deposit",
  },
  {
    action: "Withdraw Savings",
    icon: (props) => <BiMoneyWithdraw {...props} />,
    route: "/withdraw",
    id: "withdrawSavings",
  },
  {
    action: "Interest Breakdown",
    icon: () => "/breakdown.svg",
    route: "/interest",
  },
  {
    action: "Savings Settings",
    icon: (props) => <HiOutlineCog8Tooth {...props} />,
    route: "/settings",
  },
];

export const THINGS_TO_NOTE = [
  {
    title: "Interest Yield",
    description: "A flat interest rate of 18% per annum.",
    icon: () => "/yield.svg",
  },
  {
    title: "Savings Duration",
    description: "1 month minimum, 12 months maximum",
    icon: () => "/duration.svg",
  },
  {
    title: "Interest Payment",
    description: "Interest are paid at the end of each month",
    icon: () => "/payment.svg",
  },
  { title: "Savings Top-up", description: "Anytime", icon: () => "/topup.svg" },
  {
    title: "Withdrawal",
    description: "You can’t withdraw your savings before maturity date..",
    icon: (props) => <BiMoneyWithdraw {...props} />,
  },
  {
    title: "Halal Compliment",
    description: "You can opt out of receiving interests on your savings.",
    icon: () => "/compliment.svg",
  },
];

export const SAVINGS_PLAN_FORM = [
  {
    label: "Deposit Mode",
    placeholder: "Select",
    name: "is_auto_save",
    options: DEPOSIT_MODE,
  },
];

export const SAVINGS_AMOUNT = [
  "₦1,000",
  "₦2,000",
  "₦5,000",
  "₦10,000",
  "₦20,000",
  "₦50,000",
  "₦100,000",
];

export const SETTINGS_SIDEBAR_ITEMS = [
  {
    icon: "/autosave.svg",
    value: "AutoSave",
    extraIcon: "/toggle.svg",
  },
  {
    icon: "/autosavesettings.svg",
    value: "AutoSave Settings",
    extraIcon: "/arrowright.svg",
    route: "autosave-settings",
  },
];

export const CHANGED_PASSWORD_ITEMS = [
  { label: "Current Password", name: "currentPassword" },
  { label: "New Password", name: "password" },
  { label: "Confirm New Password", name: "confirmPassword" },
];

export const USER_PROFILE_FORM = [
  { label: "First Name", name: "first_name", placeholder: "Firstname" },
  { label: "Last Name", name: "last_name", placeholder: "Lastname" },
  { label: "User Name", name: "username", placeholder: "@username" },
  { label: "Phone Number", name: "phone", placeholder: "08123456789" },
];

export const TRANSACTION_HISTORY = [
  {
    name: "Savings Deposit",
    type: "Credit",
    amount: "+₦50,000.00",
    newBalance: "₦515,000.00",
    date: "Thu., 25th Nov., 2024. 14:25PM",
    status: "successful",
  },
  {
    name: "Savings Withdrawal",
    type: "Debit",
    amount: "-₦20,000.00",
    newBalance: "₦495,000.00",
    date: "Thu., 25th Nov., 2024. 15:00PM",
    status: "unsuccessful",
  },
  {
    name: "Savings Deposit",
    type: "Credit",
    amount: "+₦30,000.00",
    newBalance: "₦525,000.00",
    date: "Fri., 26th Nov., 2024. 09:30AM",
    status: "successful",
  },
  {
    name: "Savings Withdrawal",
    type: "Debit",
    amount: "-₦10,000.00",
    newBalance: "₦515,000.00",
    date: "Fri., 26th Nov., 2024. 12:00PM",
    status: "successful",
  },
  {
    name: "Savings Deposit",
    type: "Credit",
    amount: "+₦40,000.00",
    newBalance: "₦555,000.00",
    date: "Sat., 27th Nov., 2024. 10:15AM",
    status: "unsuccessful",
  },
  {
    name: "Savings Withdrawal",
    type: "Debit",
    amount: "-₦15,000.00",
    newBalance: "₦540,000.00",
    date: "Sat., 27th Nov., 2024. 11:45AM",
    status: "successful",
  },
  {
    name: "Savings Deposit",
    type: "Credit",
    amount: "+₦25,000.00",
    newBalance: "₦565,000.00",
    date: "Sun., 28th Nov., 2024. 08:30AM",
    status: "successful",
  },
  {
    name: "Savings Withdrawal",
    type: "Debit",
    amount: "-₦5,000.00",
    newBalance: "₦560,000.00",
    date: "Sun., 28th Nov., 2024. 10:00AM",
    status: "unsuccessful",
  },
];

export const PARTNERS = [vant, providus, paystack, palmpay, fcmb, pristin];

export const FEATURED = [technext, techcabal, techpoint, condia, techcity];

export const LANDING_NAV_ITEMS = [
  { title: "Cooperative", href: `${process.env.NEXT_PUBLIC_COOPERATIVE_URL}` },
  { title: "Company", href: "/company" },
  { title: "Blog", href: "/blog" },
  // { title: "FAQs", href: "/faqs" },
  { title: "Enablers", href: "/enabler" },
  { title: "Contact", href: "/contact" },
  // { title: "Legal", href: "" },
  // { title: "Privacy Policy", href: "/privacy" },
  // { title: "Terms of Use", href: "/terms" },
  // { title: "Security", href: "/security" },
];

export const LANDING_ACCORDION_ITEMS = [
  {
    summary: "Create Account & Start Saving",
    details:
      "Create your Monietab account, securely link your bank account, and you’re ready to begin your savings journey. Set up specific savings goals like a dream vacation, wedding, school fees, or general savings. Monietab helps you achieve these goals faster and more efficiently.",
  },
  {
    summary: "Automate Your Savings & Earn Interest",
    details:
      "Take the stress out of saving by automating your savings contributions. Decide how much and how often you want to save, and watch your money grow with attractive interest rates. Your savings and interest are always secure and untouched.",
  },
  {
    summary: "Earn Tabcoin as You Save and Engage",
    details:
      "The more you save, the more you earn! Tabcoin is your reward currency and does not affect your savings or interest. It’s our way of saying “thank you” for being consistent and engaged. With every milestone you achieve or activity you complete — like quizzes, games, or daily challenges — you earn Tabcoin.",
  },
  {
    summary: "Redeem Rewards Without Spending Your Savings",
    details:
      "Use your Tabcoin to redeem exciting rewards like shopping vouchers, cash prizes, discounts, and other goodies from the Reward Center. Your savings and the interest you’ve earned remain untouched — you’re only spending the Tabcoin you’ve earned along the way.",
  },
  {
    summary: "Play, Learn & Boost Your Rewards",
    details:
      "Participate in fun games, quizzes, and challenges to earn even more Tabcoin. This keeps saving engaging, rewarding, and enjoyable",
  },
];

export const WHAT_WE_STAND_FOR = [
  {
    img: "/stronger.svg",
    title: "Stronger Together",
    description:
      "Monietab is more than a platform; it’s a family. We celebrate milestones, reward loyalty, and build together.",
  },
  {
    img: "/empower.svg",
    title: "Empower Every User",
    description:
      "We believe everyone deserves access to financial tools and resources that inspire confidence and growth.",
  },
  {
    img: "/transparency.svg",
    title: "Transparency Builds Trust",
    description:
      "Trust is the foundation of our relationship with users. We ensure our processes are clear, straightforward, and easy to understand.",
  },
  {
    img: "/innovation.svg",
    title: "Innovation",
    description:
      "We are committed to breaking barriers with cutting-edge technology and creative solutions that redefine possibilities.",
  },
  {
    img: "/integrity.svg",
    title: "Integrity in Every Step",
    description:
      "We uphold the highest standards of ethics in every decision we make, ensuring our users’ trust is never compromised.",
  },
  {
    img: "/learn.svg",
    title: "Learn, Grow, Thrive",
    description:
      "Financial literacy is the cornerstone of wealth creation. Through education, we empower users to make informed decisions.",
  },
];

export const FAQS = {
  monietabOverview: [
    {
      question: "What is Monietab?",
      answer:
        "Monietab is a gamified savings platform designed to help you save money effortlessly and consistently. It combines high-yield savings opportunities with exciting features like games, rewards, and challenges to make saving enjoyable. ",
    },
    {
      question: "Why should I use Monietab?",
      answer:
        "Monietab offers higher interest rates than traditional banks, gamified features to make saving fun, and rewards like Tabcoin that can be redeemed for prizes. You can earn Tabcoin as you save, take financial lessons, and maintain streaks, which can be redeemed for exciting rewards. It’s more than just saving—it’s about building financial habits in a fun and engaging way, while also earning more from your savings. ",
    },
    {
      question:
        "How are you able to offer higher returns than traditional banks?",
      answer:
        "Monietab partners with regulated financial institutions and invests your savings in secure, low-risk financial instruments like treasury bills, bonds, and other fixed-income products. ",
    },
    {
      question: "How much can I save on Monietab?",
      answer:
        "You can save as much as you want, starting from as low as ₦1,000. There’s no maximum limit to how much you can save.",
    },
    {
      question: "How do I start saving on Monietab?",
      answer:
        "Visit <a href='https://monietab.com' target='_blank'>https://monietab.com</a> or download our app, create an account, and link your debit card. Once you’re set-up, you can choose a savings plan, decide on your preferred savings amount, and start saving. Alternatively, you can save instantly without setting up a plan using the Quick Deposit feature.",
    },
    {
      question: "Are there bank charges when you deduct from my account?",
      answer:
        "No, there are no hidden bank charges when Monietab deducts savings from your account.",
    },
    {
      question: "Do I get Interest on Monietab?",
      answer:
        "Yes, you earn competitive interest on all eligible savings plans. Depending on the type of savings product you choose, interest rates range from 8% to 25% annually. These rates are significantly higher than those offered by traditional banks, ensuring your money grows faster.",
    },
  ],
  tabcoinRewards: [
    {
      question: "Do I get Interest on Monietab?",
      answer:
        "Tabcoin is a virtual reward point system on Monietab designed to encourage and motivate users to save consistently. These coins serve as an additional incentive, making the saving experience not only rewarding financially but also enjoyable.",
    },
    {
      question: "How do I earn Tabcoin?",
      answer:
        "You earn Tabcoin by performing activities such as saving money consistently, completing financial education lessons, and staking your Tabcoin to participate in games and activities.",
    },
    {
      question: "What can I use my Tabcoin for?",
      answer:
        "Tabcoin can be used to redeem various rewards in Monietab Reward Center. The more Tabcoin you accumulate, the better the rewards you can unlock, making it a fun way to save while working toward tangible benefits.",
    },
    {
      question: "What kind of rewards can I redeem?",
      answer:
        "The rewards you can redeem with your Tabcoin range from giftcards for shopping, shopping vouchers, gadgets, airtime for your mobile phone, discounts on services, exclusive access and more, depending on the points you’ve accumulated.",
    },
  ],
  savingsAutosave: [
    {
      question: "What is Quick Deposit, and how does it work? ",
      answer:
        "Quick Deposit allows you to make an instant one-time deposit into your savings account without setting up a plan. It’s perfect for spontaneous savings or when you want to boost your existing savings quickly.",
    },
    {
      question: "Do I have to log in every time I want to save?",
      answer:
        "No, you don’t have to log in every time to save. With AutoSave, once you set up your savings plan, the app automatically deducts your chosen amount from your linked account or card at the scheduled intervals.",
    },
    {
      question: "Can I pause and continue saving anytime?",
      answer:
        "Yes, you have full control over your savings and can pause it whenever you need to. You can pause your savings without losing your existing balance or incurring any penalties. When you’re ready to continue, you can simply resume your plan and pick up where you left off.",
    },
    {
      question:
        "What happens if I miss saving for a few days, weeks, or months?",
      answer:
        "Missing savings for a period doesn’t affect your existing balance. If you skip saving for days, weeks, or even months due to insufficient funds or other reasons, your saved money remains secure, and you can continue whenever you’re ready. ",
    },
    {
      question: "Can I increase my savings at any time?",
      answer:
        "Yes, you can increase your savings at any time, either by raising your AutoSave amount or making one-time deposits through Quick Deposit.",
    },
    {
      question: "What if I don’t have funds in my account or debit card?",
      answer:
        "If your account or debit card doesn’t have enough funds on the scheduled AutoSave date, the system won’t penalize you. Instead, it will automatically try again on the next scheduled date.",
    },
  ],
  interestWithdrawal: [
    {
      question: "How are my interests paid?",
      answer:
        "Interest on your savings is calculated daily and automatically reflected on your savings balance. You can monitor your interest earnings in real-time on the platform, so you always know how much your savings are growing.",
    },
    {
      question: "What if I don’t want interest?",
      answer:
        "We understand that some users may prefer to save without earning interest for religious or personal reasons. That’s why we offer halal savings options, where your funds are securely stored without accruing interest. This ensures you can save in a way that aligns with your values.",
    },
    {
      question: "Can I monitor my savings and returns?",
      answer:
        "Yes, Monietab provides a real-time dashboard where you can track your savings, interest earned, and rewards like Tabcoin.",
    },
    {
      question: "How do Monietab withdrawals work?",
      answer:
        "You can initiate a withdrawal directly from the platform, and your funds will be transferred to your linked bank account or wallet. For early withdrawals on certain plans, penalties may apply, such as forfeiting accrued interest.",
    },
    {
      question: "Can I withdraw to any bank account?",
      answer:
        "No, withdrawals are processed only to the bank account linked to your Monietab profile for security reasons.",
    },
  ],
  safetySecurity: [
    {
      question: "Why do I have to add my BVN?",
      answer:
        "By linking your BVN to your Monietab account, we can verify your identity and prevent unauthorized access to your account. It also helps us comply with regulatory standards, ensuring that all transactions are secure and meet legal requirements.",
    },
    {
      question:
        "What if I no longer have access to the phone number linked to my BVN",
      answer:
        "If you no longer have access to the phone number linked to your BVN, you will need to update your BVN records with your bank. This process typically involves visiting a branch and providing a valid ID and proof of your new phone number. ",
    },
    {
      question: "How secure is my information?",
      answer:
        "All your personal and financial data is encrypted using industry-standard protocols, making it inaccessible to unauthorized parties. Additionally, we follow strict data protection policies and comply with regulatory frameworks like GDPR to ensure your data is stored and processed securely. We never share your information with third parties without your consent.",
    },
    {
      question: "How secure is my money?",
      answer:
        "Your savings with Monietab are held in secure accounts with licensed financial institutions that are regulated by the Central Bank of Nigeria (CBN). We also use advanced security measures, such as encryption and secure storage, to prevent unauthorized access to your funds. Your financial safety is our top priority.",
    },
    {
      question: "How does 2FA work on Monietab?",
      answer:
        "When you perform sensitive actions, such as logging in or withdrawing funds, we will send a verification code to your registered phone number or email address. You’ll need to enter this code alongside your password to complete the action. This process ensures that even if someone has your password, they won’t be able to access your account without the verification code.",
    },
    {
      question: "Are my card details safe?",
      answer:
        "Yes, your card details are fully protected. We use a PCI DSS (Payment Card Industry Data Security Standard)-compliant payment processor to handle all card transactions. This means your card information is encrypted and stored in a secure environment that meets global security standards. We do not store your card details directly, ensuring an additional layer of security",
    },
  ],
};

export const POLICY = [
  {
    title: "Introduction",
    description:
      "Welcome to Monietab! This Privacy Policy aims to help you understand how Monietab (we, us, or, our) collects, uses, stores, and protects your personal information when you use our savings and investment app that incentivizes and gamifies the savings process (the Service). We are committed to protecting your privacy and ensuring the security of your personal information. By accessing or using our Service, you agree to the terms of this Privacy Policy. If you do not agree with the practices described in this policy, please do not use our Service",
  },
  {
    title: "Information We Collect",
    description:
      "We collect personal information that you voluntarily provide when using our Service, including but not limited to your full name, email address, phone number, date of birth, home address, national identification numbers (e.g., Social Security Number, National Insurance Number), bank account information, financial details (such as income, expenses, and savings goals), profile picture, information about your savings habits and goals, next of kin details, employment information, and KYC (Know Your Customer) information. Additionally, we may automatically collect certain information about your device and usage when you use our Service, including device information (e.g., hardware model, operating system version, unique device identifiers), IP address, browser type and version, time zone setting, usage data (e.g., features used, time spent on the app, interactions), location data (with your permission), and log data (e.g., access times, pages viewed, app crashes). We may also receive information about you from third parties, such as financial institutions (with your permission), credit reporting agencies, identity verification services, marketing partners, and referral sources.",
  },
  {
    title: "How We Use Your Information",
    description:
      "We use the information we collect for various purposes, including to provide, maintain, and improve our Service, process transactions, manage your account, personalize your experience with tailored savings recommendations, communicate with you about your account, updates, and promotional offers, verify your identity to prevent fraud, analyze usage patterns to enhance our Service, comply with legal and regulatory requirements, conduct credit assessments and determine risk appetite, facilitate customer support, and conduct surveys and research to improve our Service.",
  },
  {
    title: "How We Share Your Information",
    description:
      "We may share your personal information in various circumstances, including with financial institutions to process transactions, with service providers performing services on our behalf (such as cloud storage and data analysis), with identity verification and fraud prevention services, with legal and regulatory authorities when required by law, in connection with a merger or acquisition, with our subsidiary companies for internal business purposes, with referral partners only to confirm successful referrals, and with third-party advertisers to show you relevant ads (with your consent). We do not sell your personal information to third parties for their marketing purposes.",
  },
  {
    title: "Data Security",
    description:
      "We implement appropriate technical and organizational measures to protect your personal information against unauthorized or unlawful processing, accidental loss, destruction, or damage. These measures include encryption of data in transit and at rest, regular security audits and penetration testing, access controls and authentication mechanisms, and employee training on data protection and security practices. However, please be aware that no method of transmission over the internet or method of electronic storage is completely secure, and we cannot guarantee absolute security",
  },
  {
    title: "Your Rights and Choices",
    description:
      "Depending on your location, you may have certain rights regarding your personal information, including the right to access, correct, delete, restrict or object to processing, and data portability. To exercise these rights, please contact us using the information provided in the Contact Us section. We will respond to your request within the timeframe specified by applicable law.",
  },
  {
    title: "Data Retention",
    description:
      "We retain your personal information for as long as necessary to provide our Service and comply with legal obligations. When we no longer need your personal information, we will securely delete or anonymize it. Specific retention periods may vary depending on the type of information and legal requirements.",
  },
  {
    title: "Children's Privacy",
    description:
      "Our Service is not intended for children under the age of 18. We do not knowingly collect personal information from children. If you believe we have inadvertently collected information from a child, please contact us immediately.",
  },
  {
    title: "Changes to This Privacy Policy",
    description:
      "We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the Last Updated date. For significant changes, we may provide additional notice through the app or via email. We encourage you to review this Privacy Policy periodically.",
  },
  {
    title: "International Data Transfers",
    description:
      "Your personal information may be transferred to and processed in countries other than your country of residence, which may have different data protection laws. We will take appropriate measures to protect your personal information in accordance with this Privacy Policy and applicable laws, including using standard contractual clauses or other appropriate legal mechanisms for transfers",
  },
  {
    title: "Cookies and Similar Technologies",
    description:
      "We use cookies and similar tracking technologies to collect information about your browsing activities. These technologies help us analyze app usage, personalize content, and improve our Service. You can manage your cookie preferences through your device or browser settings. For more information, please see our separate Cookie Policy.",
  },
  {
    title: "Third-Party Links",
    description:
      "Our Service may contain links to third-party websites or services. We are not responsible for the privacy practices of these third parties. We encourage you to read the privacy policies of any third-party sites you visit.",
  },
  {
    title: "Lawful Basis for Processing",
    description:
      "We process your personal information based on one or more of the following legal grounds: your consent, performance of a contract with you, compliance with a legal obligation, and our legitimate interests, provided they do not override your fundamental rights and freedoms",
  },
  {
    title: "Breach Notification",
    description:
      "In the event of a personal data breach likely to result in a high risk to your rights and freedoms, we will notify you and the relevant supervisory authority without undue delay, in accordance with applicable law.",
  },
  {
    title: "Contact Us",
    description:
      "If you have any questions, concerns, or requests regarding this Privacy Policy or our data practices, please contact us at:  Monietab Privacy Team  Email: hello@monietab.com  Address: Plot 4, 5 Adeloye Oladejo street, Alagbaka, Akure 340001, Ondo State, Nigeria.",
  },
  {
    title: "Governing Law",
    description:
      "This Privacy Policy shall be governed by and construed in accordance with the laws of Nigeria without regard to its conflict of law provisions.",
  },
  {
    title: "Your Consent",
    description:
      "By using our Service, you consent to the collection, use, and sharing of your personal information as described in this Privacy Policy. You may withdraw your consent at any time, but this may affect your ability to use certain features of our Service",
  },
];

export const DELETION_STEPS = {
  inAppDeletion: [
    "Open the Monietab app and navigate to User Profile.",
    "Select Account and then tap on Delete Account.",
    "Confirm your decision, and your account along with all associated data will be permanently deleted within 24 hours.",
  ],
  viaEmailDeletion: [
    "You can also request account deletion by emailing our support team at hello@monietab.com from the email address associated with your account.",
    "Include your full name and registered phone number in the email for verification.",
    "Our team will process your request within 48 hours and confirm the deletion of your account.",
  ],
  considerations: [
    "Data Deletion is Permanent: Once your account is deleted, your savings history, Tabcoin, and rewards will be permanently erased and cannot be recovered.",
    "Pending Transactions: Ensure all transactions are complete or withdraw any remaining funds before deleting your account, as any balance may be forfeited upon deletion",
  ],
};

export const SECURITY_APPROACH = [
  {
    title: "Bank-Grade Encryption:",
    description:
      "We use advanced encryption methods to protect all user data, whether stored or in transit. This means your personal information and transactions are shielded from unauthorized access, providing bank-level security for your peace of mind.",
  },
  {
    title: "Secure Wallet System:",
    description:
      "Your funds are kept in secure digital wallets backed by a reputable financial institution, providing additional security for your deposits, ensuring your funds are safe and accessible at all times.",
  },
  {
    title: " Two-Factor Authentication (2FA):",
    description:
      " To prevent unauthorized access, we use Two-Factor Authentication (2FA) across our platform. With 2FA, you receive an extra layer of security, ensuring only you can access your account and authorize transactions.",
  },
  {
    title: " Continuous Monitoring:",
    description:
      " Our team actively monitors Monietab accounts for unusual or suspicious activities. We use cutting-edge technology and dedicated security experts to protect our users from potential threats.",
  },
  {
    title: " Regulatory Compliance:",
    description:
      " Monietab is fully compliant with Nigerian financial regulations and standards, meaning your savings are not only secure but also governed by legal protections. We work closely with our banking partners to ensure that your funds are always protected.",
  },
];
export const ACCORDION_IMAGE = [
  "/phone.svg",
  "/automate.svg",
  "/earn.svg",
  "/redeem.svg",
  "/play.svg",
];

export const SOCIAL_ICONS = [
  {
    icon: <BsLinkedin />,
    href: "https://www.linkedin.com/company/monietab/",
  },
  { icon: <BsInstagram />, href: "https://www.instagram.com/monietab/" },
  { icon: <BsFacebook />, href: "https://facebook.com/monietab" },
  { icon: <BsTiktok />, href: "https://www.tiktok.com/@monietab" },
  { icon: <BsTwitterX />, href: "https://x.com/monietab" },
  { icon: <BsYoutube />, href: "https://www.youtube.com/@monietab" },
  { icon: <BsMedium />, href: " https://medium.com/@monietab" },
];

export const NAV_ITMES = [
  {
    icon: (props) => <MdOutlineDashboard {...props} />,
    title: "Dashboard",
    route: "/dashboard",
  },
  {
    icon: (props) => <MdOutlineSavings {...props} />,
    title: "Hold Tab",
    route: "/tabhold",
  },
  {
    icon: (props) => <MdOutlinePeople {...props} />,
    title: "Co-operative",
    route: "/coming-soon",
  },
  {
    icon: (props) => <BsWallet {...props} />,
    title: "Wallet",
    route: "/wallet",
  },
  {
    icon: (props) => <BiMedal {...props} />,
    title: "Reward Center",
    route: "/reward",
  },
];

export const QUICK_TASK = [
  {
    icon: "/verify.svg",
    title: "Verify your identity",
    route: "bvn-verification",
    id: "bvnForm",
  },
  {
    icon: "/about.svg",
    title: "Tell us about yourself",
    route: "profile",
    id: "aboutForm",
  },
  {
    icon: "/bank.svg",
    title: "Add withdrawal bank account",
    route: "bank-account",
    id: "withdrawalAccountForm",
  },
];

let years = [];

for (let index = 1997; index < 2003; index++) {
  years.push({ label: String(index), value: String(index) });
}

export const ABOUT_YOURSELF_ITEMS = [
  {
    label: "Relationship Status",
    name: "relationship_status",
    options: [
      { label: "Single", value: "Single" },
      { label: "Married", value: "Married" },
      { label: "Divorced", value: "Divorced" },
    ],
  },
  {
    label: "Employment Status",
    name: "employment_status",
    options: [
      { label: "Student", value: "Student" },
      { label: "Unemployed", value: "Unemployed" },
      { label: "Self-Employed", value: "Self-Employed" },
      { label: "Employed", value: "Employed" },
    ],
  },
  {
    label: "How much do you earn in a year?",
    name: "income_level",
    options: [
      { label: "₦30,000 - ₦50,000", value: "30,000 - 50,000" },
      { label: "₦100,000 - ₦200,000", value: "100,000 - 200,000" },
      { label: "₦200,000 - ₦300,000", value: "200,000 - 300,000" },
      { label: "₦300,000 - ₦500,000", value: "300,000 - 500,000" },
      { label: "₦500,000 - above", value: "500,000 - above" },
    ],
  },
];

export const TRANSACTION_TYPES = [
  { type: "", text: "All" },
  { type: "credit", text: "Inflows" },
  { type: "debit", text: "Outflows" },
];

export const PAYMENT_METHODS = [
  { title: "Linked Banks", icon: "/banks.svg", method: "bank" },
  { title: "Linked Cards", icon: "/cards.svg", method: "card" },
];

export const FUND_SOURCE = [
  { text: "Card", id: "CARD" },
  { text: "Wallet", id: "VAULT" },
  { text: "Bank", id: "BANK TRANSFER" },
];

export const PAYMENT_OPTIONS = {
  wallet: "VAULT",
  bank: "BANK TRANSFER",
  card: "CARD",
};

export const TRANSACTION_SOURCES = {
  wallet: "Vault",
  hold: "Hold",
  flex: "Flex",
  payout: "Payout",
};
